/**
 * Reading the action policy's decisions on a screen.
 *
 * @module components/shared/action-decisions
 */

import type { ActionDecision, ProgrammeAction } from "@/server/action-policy";

/** One action's decision, when the read carried it. */
export function decisionFor(
  decisions: readonly ActionDecision[] | undefined,
  action: ProgrammeAction,
): ActionDecision | undefined {
  return decisions?.find((entry) => entry.action === action);
}

/**
 * Whether a screen offers the action at all.
 *
 * A conflict is shown disabled with its reason, since the reader can act on
 * it. An action this reader may never take here, or one the state has no use
 * for, is left out.
 */
export function offered(decision: ActionDecision | undefined): decision is ActionDecision {
  return decision !== undefined && (decision.allowed || decision.refusal?.code === "conflict");
}
